import BasePopupHandler from './BasePopupHandler';
import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import GameObject from '../../../GameObject/GameObject';
import Element from '../../../Prototype/UI/Element';
import UITextComponent from '../../../Component/UI/Text';
import { IRewardData } from '../../../Utility/RewardHelper';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { IMessagePayload } from '../../../State/Game/IEntryPointData';
import { PopupID } from '../../../State/UI/PopupID';

export default class SentGiftMenuHandler extends BasePopupHandler {
    public static REWARD_AMOUNT_NAME: string = 'reward_amount_text';
    public static REWARD_TEXT_ICON_NAME: string = 'reward_amount_icon';
    public static REWARD_ICON_NAME: string = 'reward_icon';
    public static FRIEND_MESSAGE_NAME: string = 'friend_message_text';

    private reward: IRewardData;
    private payload: IMessagePayload;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.SEND_GIFT_MENU, uiSystem);
    }

    onShow(params?: { reward: IRewardData; payload: IMessagePayload }) {
        super.onShow(params);

        this.reward = params.reward;
        this.payload = params.payload;

        const rewardAmount: GameObject = GameObject.findByName(
            SentGiftMenuHandler.REWARD_AMOUNT_NAME
        )[0];
        rewardAmount.getComponent(
            UITextComponent
        ).text = params.reward.value.toString();

        const friendMessage: GameObject = GameObject.findByName(
            SentGiftMenuHandler.FRIEND_MESSAGE_NAME
        )[0];
        const friendMessageText: string = Game.locale
            .getText('SentCoinsTo')
            .replace('[x]', params.payload.userName);

        friendMessage.getComponent(UITextComponent).text = friendMessageText;

        if (this.element !== undefined) {
            this.system.scene.emit(
                RenderSystemEvent.BRING_TO_FRONT,
                this.element
            );
        }
    }

    createPopup(params?: any) {
        this.underlayParams.cacheKey = 'level_complete_underlay';
        this.submitBtnParams.button.cacheKey = 'button_medium_green';
        this.submitBtnParams.text.textLocalizationKey = 'Great';
        this.submitBtnParams.text.style = Game.style.getStyle(
            'popup.green_btn'
        );
        this.submitBtnParams.onClick = this.onSubmit.bind(this);

        super.createPopup({
            buttons: [this.submitBtnParams],
            underlay: this.underlayParams,
            title: 'SentGift',
        });

        const rewardIcon: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: `reward_icon`,
            layout: {
                anchors: [0.5, 0.375, 0.5, 0.375],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'coins_gift',
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: `friend_message_text`,
                    layout: {
                        anchors: [0.5, 1, 0.5, 1],
                        pivot: [0.5, 0],
                        offsets: [0, -35, 0, -35],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'SentCoinsTo',
                                style: Game.style.getStyle(
                                    'popup.friends_hub.friend_name'
                                ),
                                align: 'center',
                                bounds: [500, 80],
                            },
                        },
                    ],
                },
            ],
        });
        this.background.addChild(rewardIcon);

        const rewardAmountDisplay: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: `reward_amount_group`,
            layout: {
                anchors: [0.45, 0.725, 0.45, 0.725],
                pivot: [0, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'text_bg_short',
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: `reward_amount_icon`,
                    layout: {
                        anchors: [0, 0.5, 0, 0.5],
                        pivot: [0.25, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'coin_medium_popup',
                            },
                        },
                    ],
                    children: [],
                },
                {
                    type: 'group',
                    name: `reward_title_text`,
                    layout: {
                        anchors: [0, 0.45, 0, 0.45],
                        pivot: [1, 0.5],
                        offsets: [25, 0, 25, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'YouSent',
                                style: Game.style.getStyle('popup.Reward_Text'),
                                align: 'right',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: `reward_amount_text`,
                    layout: {
                        anchors: [0.5, 0.45, 0.5, 0.45],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                text: '999',
                                style: Game.style.getStyle(
                                    'popup.Reward_Amount'
                                ),
                                align: 'center',
                            },
                        },
                    ],
                },
            ],
        });
        this.background.addChild(rewardAmountDisplay);
    }

    protected onSubmit(): void {
        this.closePopup();
    }
    protected onClose(): void {
        super.onClose();

        PlayerActions.showLevelAutoFlowPopup({ delay: 300 });
    }
}
